/* eslint-disable jsx-a11y/anchor-is-valid */
import $ from 'jquery';
import React, { useCallback, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildLegacyI18n } from '@bingads-webui/build-legacy-i18n';
import { mergeI18n } from '@bingads-webui-campaign-react/i18n-merger';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getDeliveryStatusStyle } from './delivery-status-style';
import { DeliveryStatus as DeliveryStatusEnum } from '../constants/delivery-status';
import { legacyI18nKeys } from '../constants/legacy-i18n';

const UnstyledDeliveryStatus = (props) => {
  const {
    DeliveryStatus,
    classes,
    i18n: newI18n,
  } = props;

  const i18n = useMemo(() => mergeI18n(
    buildLegacyI18n(newI18n, legacyI18nKeys),
    newI18n
  ), [newI18n]);

  const containerRef = useRef(null);

  const hideDeliveryStatusDetails = useCallback(() => {
    if (containerRef.current) {
      $(containerRef.current).trigger('closeDeliveryStatusPopup');
    }
  }, []);

  const hideDeliveryStatusDetailsOnMouseLeave = useCallback((event) => {
    if ($(event.relatedTarget).closest('#delivery-status-popup-callout').length === 0) {
      hideDeliveryStatusDetails();
    }
  }, [hideDeliveryStatusDetails]);

  return (
    <div
      className={classNames(['appads-asset-group-delivery-status', classes.statusContainer])}
      onMouseLeave={hideDeliveryStatusDetailsOnMouseLeave}
      ref={containerRef}
    >
      {DeliveryStatus === DeliveryStatusEnum.Eligible && i18n.getString(DeliveryStatusEnum.Eligible)}
      {DeliveryStatus !== DeliveryStatusEnum.Eligible && (i18n.getString(DeliveryStatusEnum[DeliveryStatus] || ''))}
    </div>
  );
};

UnstyledDeliveryStatus.propTypes = {
  DeliveryStatus: PropTypes.string.isRequired,
  appealOptions: PropTypes.shape({}).isRequired,
  classes: PropTypes.shape({
    statusContainer: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      aid: PropTypes.number,
      cid: PropTypes.number,
      campaignId: PropTypes.number,
    }),
  }).isRequired,
  permissions: PropTypes.shape({}).isRequired,
};

export const DeliveryStatus = withDefaultStyles(UnstyledDeliveryStatus, getDeliveryStatusStyle);
